import React, { Component } from "react";
import PropTypes from "prop-types";
import { DURATION_PIXEL_RATIO } from "../../_components/styled/variable";

class Ruler extends Component {
  constructor(props) {
    super(props);
    this.canvasElement = React.createRef();
    this.canvasContext = null;
    this.divisionsElement = null;
    this.width = 0;
    this.height = 0;
    this.state = {};
  }

  onClickRuler = (e) => {
    const { onClick, scale } = this.props;
    let rect = e.currentTarget.getBoundingClientRect();
    let x = e.clientX - rect.left;
    const durationToSeek = x / (DURATION_PIXEL_RATIO * scale);
    onClick(durationToSeek);
  };

  render() {
    return (
      <canvas
        ref={this.canvasElement}
        style={this.props.style}
        onClick={this.onClickRuler}
      />
    );
  }

  componentDidMount() {
    const canvas = this.canvasElement.current;
    const context = canvas.getContext("2d");
    this.canvasContext = context;
    window.ruler = this;
    this.resize();
  }

  componentDidUpdate(prevProps, prevState) {
    this.resize();
  }

  scroll = (scrollPos) => {
    this.draw(scrollPos);
  };

  resize = () => {
    const canvas = this.canvasElement.current;
    const { width, height, scrollPos } = this.props;

    this.width = canvas.offsetWidth;
    this.height = canvas.offsetHeight;
    canvas.width = this.width;
    canvas.height = this.height;
    this.draw(scrollPos);
  };

  draw = () => {
    const props = this.props;
    const {
      unit,
      scale,
      type,
      backgroundColor,
      lineColor,
      textColor,
      direction,
      segment = 5,
      textFormat,
      showFirstTextLeftAligned,
    } = props;
    const width = this.width;
    const height = this.height;
    const context = this.canvasContext;
    const isDirectionStart = direction === "start";
    const font = props.font || "10px sans-serif";
    const textAlign = props.textAlign || "left";
    const textOffset = props.textOffset || [0, 0];
    const containerSize = height;
    const longLineSize = props.longLineSize || 7;
    const shortLineSize = props.shortLineSize || 5;

    if (backgroundColor === "transparent") {
      // Clear existing paths & text
      context.clearRect(0, 0, width, height);
    } else {
      // Draw the background
      context.rect(0, 0, width, height);
      context.fillStyle = backgroundColor;
      context.fill();
    }

    context.save();
    context.scale(1, 1);
    context.strokeStyle = lineColor;
    context.lineWidth = 1;
    context.font = font;
    context.fillStyle = textColor;

    if (isDirectionStart) {
      context.textBaseline = "top";
    }
    context.translate(0.5, 0);
    context.beginPath();

    const size = width;
    const scaleUnit = scale * DURATION_PIXEL_RATIO * unit;
    // const minRange = Math.floor((scale) / scaleUnit);
    const minRange = 0;
    const maxRange = Math.ceil(size / scaleUnit);
    const length = maxRange - minRange;
    const alignOffset = Math.max(
      ["left", "center", "right"].indexOf(textAlign) - 1,
      -1
    );

    for (let i = 0; i <= length; ++i) {
      const value = i + minRange;

      if (value < 0) {
        continue;
      }
      const startPos = value * scale * DURATION_PIXEL_RATIO * unit;
      for (let j = 0; j < segment; ++j) {
        const pos = startPos + (j / segment) * scaleUnit;

        if (pos < 0 || pos >= size) {
          continue;
        }
        const lineSize = j === 0 ? longLineSize : shortLineSize;

        const [x1, y1] = [pos, isDirectionStart ? 0 : height - lineSize];
        const [x2, y2] = [x1, y1 + lineSize];
        context.moveTo(x1, y1);
        context.lineTo(x2, y2);
      }

      if (startPos >= -scaleUnit && startPos < size + unit * scale) {
        const [startX, startY] = [
          startPos + alignOffset * -3,
          isDirectionStart ? 12 : height - 12,
        ];

        let text = `${Number(value * unit).toFixed(1)}s`;

        if (textFormat) {
          text = textFormat(value * unit);
        }

        context.textAlign =
          i === 0 && showFirstTextLeftAligned ? "left" : textAlign;

        context.fillText(text, startX + textOffset[0], startY + textOffset[1]);
      }
    }
    context.stroke();
    context.restore();
  };
}

Ruler.defaultProps = {
  scale: 1,
  width: 0,
  height: 0,
  unit: 1,
  mainLineSize: 15,
  longLineSize: 10,
  shortLineSize: 7,
  segment: 5,
  direction: "end",
  style: { width: "100%", height: "100%" },
  backgroundColor: "#333333",
  font: "10px sans-serif",
  textColor: "#ffffff",
  lineColor: "#777777",
  showFirstTextLeftAligned: false,
};

Ruler.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  scale: PropTypes.number,
  direction: PropTypes.oneOf(["start", "end"]),
  textAlign: PropTypes.oneOf(["left", "center", "right"]),
  font: PropTypes.string,
  segment: PropTypes.number,
  longLineSize: PropTypes.number,
  shortLineSize: PropTypes.number,
  textOffset: PropTypes.number,
  scrollPos: PropTypes.number,
  style: PropTypes.object,
  backgroundColor: PropTypes.string,
  lineColor: PropTypes.string,
  textColor: PropTypes.string,
  textFormat: PropTypes.func,
  onClick: PropTypes.func,
  showFirstTextLeftAligned: PropTypes.bool,
};

export default Ruler;
